import { useEffect, useState, useCallback, useRef } from "react";
import axios from "axios";
import {
  Box,
  Button,
  Text,
  Input,
  Flex,
  GridItem,
  HStack,
  IconButton,
  Grid,
  Image,
  VStack,
  Heading,
  FormLabel,
  Textarea,
  List,
  ListItem,
  Spinner,
  useToast,
} from "@chakra-ui/react";
import { Link, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { IoIosCloseCircle } from "react-icons/io";
import { FaRegImage } from "react-icons/fa6";
import { FiEdit, FiEdit2, FiPlus, FiTrash2 } from "react-icons/fi";
import { MdOutlineAddBox } from "react-icons/md";
import { RxCrossCircled } from "react-icons/rx";
import { Select as ChakraSelect } from "chakra-react-select";
import FloatingLabelInput from "../../../components/FloatInput";
import MultiSelect from "../../../components/MultiSelect";
import LabelInput from "../../../components/Input";
import PickupTime from "../../../components/PickupTime";
import InputTime from "../../../components/InputTime";
import InputAndDragAndDrop from "../../../components/InputWithDragAndDrop";
import { fetchSuggestions } from "../../../actions/location.actions";
import { fetchAllVehiclesList } from "../../../actions/management.action";
        // ...existing code...
        import { Switch } from "@chakra-ui/react";

const Form = ({
  data,
  setData,
  handleSubmit,
  formRef,
  isEditMode = false,
  isSaving = false,
}) => {
  const [preview, setPreview] = useState(null);
  const [days, setDays] = useState([]);
  const [editorContent, setEditorContent] = useState({});
  const [files, setFiles] = useState({});
  const [errors, setErrors] = useState({});
  const toast = useToast();
  const navigate = useNavigate();
const [showDaywisePricing, setShowDaywisePricing] = useState(false);

  // Location autocomplete states
  const [startLocationSuggestions, setStartLocationSuggestions] = useState([]);
  const [endLocationSuggestions, setEndLocationSuggestions] = useState([]);
  const [loadingStartLocation, setLoadingStartLocation] = useState(false);
  const [loadingEndLocation, setLoadingEndLocation] = useState(false);
  const [showStartDropdown, setShowStartDropdown] = useState(false);
  const [showEndDropdown, setShowEndDropdown] = useState(false);
  const debounceTimerRef = useRef(null);

  // Stops autocomplete states
  const [stopsSuggestions, setStopsSuggestions] = useState([]);
  const [loadingStops, setLoadingStops] = useState({});
  const [showStopsDropdown, setShowStopsDropdown] = useState({});

  // Vehicle segment states
  const [vehiclesList, setVehiclesList] = useState([]);
  const [loadingVehicles, setLoadingVehicles] = useState(false);
  const [calculatingAmount, setCalculatingAmount] = useState(false);

  const todayDate = new Date().toISOString().split("T")[0];
  const generateUniqueCode = () => {
    const randomPart = Math.random().toString(36).slice(2, 7).toUpperCase();
    return `PKG-${randomPart}`;
  };

  const activities = ["Adventure", "Relaxation", "Culture"];

  const activityOptions = activities.map((value) => ({ value, label: value }));
  const categoryOptions = [
    { value: "adventure", label: "Adventure" },
    { value: "budget", label: "Budget" },
  ];
  const packageTypeOptions = [
    { value: "hills", label: "Hills" },
    { value: "historic", label: "Historic" },
    { value: "luxury", label: "Luxury" },
    { value: "desert", label: "Desert" },
    { value: "cityTour", label: "City Tour" },
    { value: "beach", label: "Beach" },
    { value: "adventure", label: "Adventure" },
    { value: "wildlife", label: "Wildlife" },
    { value: "religious", label: "Religious" },
    { value: "heritage", label: "Heritage" },
    { value: "wellness", label: "Wellness" },
    { value: "foodTour", label: "Food Tour" },
    { value: "romantic", label: "Romantic" },
  ];
  const pricingTypeOptions = [
    { value: "perPerson", label: "Per Person" },
    { value: "perVehicle", label: "Per Vehicle/Group" },
  ];
  const currencyOptions = [
    { value: "INR", label: "INR" },
    { value: "USD", label: "USD" },
    { value: "EUR", label: "EUR" },
    { value: "GBP", label: "GBP" },
  ];
  const productStatusOptions = [
    { value: "draft", label: "Draft" },
    { value: "active", label: "Active" },
    { value: "inactive", label: "Inactive" },
  ];

  const durationDays = Number(
    String(data?.duration || "").match(/-?\d+/)?.[0] || 0,
  );
  const canAddDays = durationDays > 0;
  const isAtDayLimit = canAddDays && days.length >= durationDays;

  useEffect(() => {
    if (!durationDays) {
      if (days.length) setDays([]);
      if (Object.keys(editorContent).length) setEditorContent({});
      return;
    }

    setDays((prevDays) => prevDays.filter((day) => day <= durationDays));
    setEditorContent((prevContent) => {
      const nextContent = {};
      Object.keys(prevContent).forEach((key) => {
        const dayNum = Number(key);
        if (dayNum <= durationDays) {
          nextContent[key] = prevContent[key];
        }
      });
      return nextContent;
    });
  }, [durationDays]);

  useEffect(() => {
    if (!data?.uniqueCode) {
      setData((prev) => ({
        ...prev,
        uniqueCode: generateUniqueCode(),
      }));
    }
  }, [data?.uniqueCode]);

  const selectStyles = {
    variant: "filled",
    borderRadius: "lg",
    h: "52px",
    bg: "gray.50",
    border: "1px solid",
    borderColor: "gray.200",
    fontSize: "sm",
    color: "gray.800",
    iconColor: "gray.500",
    _hover: { bg: "white", borderColor: "gray.300" },
    _focus: {
      bg: "white",
      borderColor: "blue.500",
      boxShadow: "0 0 0 1px #3182CE",
    },
  };

  const dropdownStyles = {
    control: (base) => ({
      ...base,
      minHeight: "52px",
      borderRadius: "12px",
      backgroundColor: "#FFFFFF",
      borderColor: "#E2E8F0",
      borderWidth: "1px",
      boxShadow: "none",
      _hover: { borderColor: "#CBD5E0", backgroundColor: "#FFFFFF" },
    }),
    menu: (base) => ({
      ...base,
      borderRadius: "12px",
      boxShadow: "0 10px 30px rgba(0,0,0,0.12)",
      overflow: "hidden",
    }),
    menuList: (base) => ({
      ...base,
      padding: 0,
      maxHeight: "240px",
    }),
    option: (base, state) => ({
      ...base,
      fontSize: "14px",
      padding: "10px 14px",
      backgroundColor: state.isSelected
        ? "#3182CE"
        : state.isFocused
          ? "#EBF4FF"
          : "#FFFFFF",
      color: state.isSelected ? "#FFFFFF" : "#1A202C",
    }),
    placeholder: (base) => ({
      ...base,
      color: "#A0AEC0",
      fontSize: "14px",
    }),
    singleValue: (base) => ({
      ...base,
      fontSize: "14px",
      color: "#1A202C",
    }),
  };

  const filledInputStyles = {
    variant: "outline",
    bg: "white",
    borderColor: "gray.200",
    borderWidth: "1px",
    _hover: { bg: "white", borderColor: "gray.300" },
    _focus: {
      bg: "white",
      borderColor: "blue.500",
      boxShadow: "0 0 0 1px #3182CE",
    },
  };

  const handleSelectChange = (name) => (option) => {
    setData((prevData) => ({
      ...prevData,
      [name]: option?.value || "",
    }));
  };

  const TITLE_MAX = 80;
  const LOCATION_MAX = 120;
  const TRAVELLERS_MIN = 1;
  const TRAVELLERS_MAX = 99;

  const titleRegex = /^[a-zA-Z0-9\s,.'-]+$/;
  const locationRegex = /^[a-zA-Z\s,.'-]+$/;
  const setFieldError = (name, message) => {
    setErrors((prev) => ({ ...prev, [name]: message }));
  };

  const validateField = (name, rawValue) => {
    const value = String(rawValue || "").trim();

    if (name === "packageTitle") {
      if (!value) return "Package title is required.";
      if (value.length < 3) return "Enter a meaningful title (min 3 chars).";
      if (value.length > TITLE_MAX)
        return `Max ${TITLE_MAX} characters allowed.`;
      if (!titleRegex.test(value))
        return "Use letters, numbers, spaces, commas, periods, apostrophes, and dashes only.";
      return "";
    }

    if (name === "uniqueCode") {
      if (!value) return "Unique code is required.";
      return "";
    }

    if (name === "startLocation" || name === "endLocation") {
      if (!value) return "Location is required.";
      if (value.length > LOCATION_MAX)
        return `Max ${LOCATION_MAX} characters allowed.`;
      if (!locationRegex.test(value))
        return "Use letters, spaces, commas, and dashes only.";
      return "";
    }

    if (name === "duration") {
      if (!value) return "Duration is required.";
      if (!/\d/.test(value)) return "Enter a valid duration.";
      return "";
    }

    if (
      name === "category" ||
      name === "activity" ||
      name === "packageType" ||
      name === "pricingType"
    ) {
      if (!value) return "This field is required.";
      return "";
    }

    if (name === "vehicleSegment") {
      if (data?.pricingType === "perVehicle" && !value)
        return "Vehicle segment is required.";
      return "";
    }

    if (name === "amountWithoutStay" || name === "amountWithStay") {
      if (!value) return "Amount is required.";
      if (Number.isNaN(Number(value))) return "Enter a valid amount.";
      return "";
    }

    if (name === "travellers") {
      if (!value) return "Travellers is required.";
      const num = Number(value);
      if (!Number.isInteger(num)) return "Travellers must be a number.";
      if (num < TRAVELLERS_MIN || num > TRAVELLERS_MAX)
        return `Travellers must be ${TRAVELLERS_MIN}-${TRAVELLERS_MAX}.`;
      return "";
    }

    return "";
  };

  const validateAll = () => {
    const fields = [
      "packageTitle",
      "uniqueCode",
      "startLocation",
      "endLocation",
      "duration",
      "category",
      "activity",
      "packageType",
      "pricingType",
      "amountWithoutStay",
      "amountWithStay",
      "travellers",
    ];
    if (data?.pricingType === "perVehicle") {
      fields.push("vehicleSegment");
    }
    const nextErrors = {};
    fields.forEach((field) => {
      const message = validateField(field, data?.[field]);
      if (message) nextErrors[field] = message;
    });
    setErrors((prev) => ({ ...prev, ...nextErrors }));
    return Object.keys(nextErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    let nextValue = value;
    if (name === "travellers") {
      nextValue = value.replace(/\D+/g, "");
    }
    if (name === "duration") {
      nextValue = value;
    }
    if (name === "packageTitle") {
      nextValue = value.replace(/[^a-zA-Z0-9\s,.'-]/g, "");
      nextValue = nextValue.replace(/\s+/g, " ");
    }

    setData((prevData) => ({
      ...prevData,
      [name]: nextValue,
    }));

    if (
      [
        "packageTitle",
        "uniqueCode",
        "startLocation",
        "endLocation",
        "duration",
        "category",
        "activity",
        "packageType",
        "pricingType",
        "amountWithoutStay",
        "amountWithStay",
        "travellers",
      ].includes(name)
    ) {
      setFieldError(name, validateField(name, nextValue));
    }
  };

  // Debounced location search
  const handleLocationChange = useCallback((name, value) => {
    setData((prevData) => ({ ...prevData, [name]: value }));

    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }

    if (!value.trim()) {
      if (name === "startLocation") {
        setStartLocationSuggestions([]);
        setShowStartDropdown(false);
      } else {
        setEndLocationSuggestions([]);
        setShowEndDropdown(false);
      }
      return;
    }

    debounceTimerRef.current = setTimeout(async () => {
      if (name === "startLocation") {
        setLoadingStartLocation(true);
        setShowStartDropdown(true);
      } else {
        setLoadingEndLocation(true);
        setShowEndDropdown(true);
      }

      try {
        const response = await fetchSuggestions(value, "address");
        const suggestions = response?.data || [];

        if (name === "startLocation") {
          setStartLocationSuggestions(suggestions);
        } else {
          setEndLocationSuggestions(suggestions);
        }
      } catch (error) {
        console.error("Error fetching location suggestions:", error);
      } finally {
        if (name === "startLocation") {
          setLoadingStartLocation(false);
        } else {
          setLoadingEndLocation(false);
        }
      }
    }, 300);
  }, []);

  const handleLocationSelect = (name, location) => {
    setData((prevData) => ({ ...prevData, [name]: location.description }));
    if (name === "startLocation") {
      setShowStartDropdown(false);
      setStartLocationSuggestions([]);
    } else {
      setShowEndDropdown(false);
      setEndLocationSuggestions([]);
    }
  };

  // Stops handlers
  const handleStopChange = useCallback(
    async (index, value) => {
      const newStops = [...(data.stops || [])];
      newStops[index] = value;
      setData((prevData) => ({ ...prevData, stops: newStops }));

      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }

      if (!value.trim()) {
        setStopsSuggestions((prev) => ({ ...prev, [index]: [] }));
        setShowStopsDropdown((prev) => ({ ...prev, [index]: false }));
        return;
      }

      debounceTimerRef.current = setTimeout(async () => {
        setLoadingStops((prev) => ({ ...prev, [index]: true }));
        setShowStopsDropdown((prev) => ({ ...prev, [index]: true }));

        try {
          const response = await fetchSuggestions(value, "address");
          const suggestions = response?.data || [];
          setStopsSuggestions((prev) => ({ ...prev, [index]: suggestions }));
        } catch (error) {
          console.error("Error fetching stop suggestions:", error);
        } finally {
          setLoadingStops((prev) => ({ ...prev, [index]: false }));
        }
      }, 300);
    },
    [data.stops],
  );

  const handleStopSelect = (index, location) => {
    const newStops = [...(data.stops || [])];
    newStops[index] = location.description;
    setData((prevData) => ({ ...prevData, stops: newStops }));
    setShowStopsDropdown((prev) => ({ ...prev, [index]: false }));
    setStopsSuggestions((prev) => ({ ...prev, [index]: [] }));
  };

  const addStop = () => {
    setData((prev) => ({
      ...prev,
      stops: [...(prev.stops || []), ""],
    }));
  };

  const removeStop = (index) => {
    const newStops = (data.stops || []).filter((_, i) => i !== index);
    setData((prevData) => ({ ...prevData, stops: newStops }));
  };

  // Inclusions and Exclusions handlers
  const addInclusion = () => {
    setData((prev) => ({
      ...prev,
      inclusionsAndExclusions: [...(prev.inclusionsAndExclusions || []), ""],
    }));
  };

  const removeInclusion = (index) => {
    const newList = (data.inclusionsAndExclusions || []).filter(
      (_, i) => i !== index,
    );
    setData((prevData) => ({
      ...prevData,
      inclusionsAndExclusions: newList,
    }));
  };

  const handleInclusionChange = (index, value) => {
    const newList = [...(data.inclusionsAndExclusions || [])];
    newList[index] = value;
    setData((prevData) => ({
      ...prevData,
      inclusionsAndExclusions: newList,
    }));
  };

  // Cancellation Policy handlers
  const addCancellationPolicy = () => {
    setData((prev) => ({
      ...prev,
      cancellationPolicy: [...(prev.cancellationPolicy || []), ""],
    }));
  };

  const removeCancellationPolicy = (index) => {
    const newList = (data.cancellationPolicy || []).filter(
      (_, i) => i !== index,
    );
    setData((prevData) => ({
      ...prevData,
      cancellationPolicy: newList,
    }));
  };

  const handleCancellationPolicyChange = (index, value) => {
    const newList = [...(data.cancellationPolicy || [])];
    newList[index] = value;
    setData((prevData) => ({
      ...prevData,
      cancellationPolicy: newList,
    }));
  };

  const handleAddDay = () => {
    if (!canAddDays) return;
    setDays((prevDays) => {
      const nextDay = (prevDays.length ? Math.max(...prevDays) : 0) + 1;
      if (durationDays > 0 && nextDay > durationDays) return prevDays;
      return [...prevDays, nextDay];
    });
  };

  const handleRemoveDay = (day) => {
    setDays((prevDays) => prevDays.filter((d) => d !== day));
    setEditorContent((prevContent) => {
      const newContent = { ...prevContent };
      delete newContent[day];
      return newContent;
    });
  };

  const handleEditorChange = (day, content) => {
    setEditorContent((prevContent) => ({
      ...prevContent,
      [day]: content,
    }));
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();

    if (!validateAll()) {
      toast({
        title: "Missing required fields",
        description: "Please fill all required fields to save.",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    const normalizeArrayForSubmit = (arr) => {
      if (!Array.isArray(arr)) return arr;
      if (arr.length === 1 && typeof arr[0] === "string") {
        const maybeJson = arr[0].trim();
        if (maybeJson.startsWith("[") && maybeJson.endsWith("]")) {
          try {
            const parsed = JSON.parse(maybeJson);
            if (Array.isArray(parsed)) return parsed;
          } catch (e) {
            return arr;
          }
        }
      }
      return arr;
    };

    const journey = days.map((day) => ({
      day,
      location: editorContent[`${day}_location`] || "",
      accommodation: editorContent[`${day}_accommodation`] || "",
      itinerary: (editorContent[`${day}_itinerary`] || []).map(item => ({
        attraction: item.title || "",
        details: item.description || ""
      })),
      foodAndDrinks: (editorContent[`${day}_meals`] || []).map(item => ({
        mealType: item.type || "",
        menuDetails: item.menu || ""
      }))
    }));

    const formData = new FormData();

    // Fields that should always be included, even if empty
    const requiredFields = [
      "packageTitle",
      "uniqueCode",
      "startLocation",
      "endLocation",
      "category",
      "activity",
      "duration",
      "packageType",
      "pricingType",
      "amountWithoutStay",
      "amountWithStay",
      "travellers",
      "inclusionsAndExclusions",
      "cancellationPolicy",
    ];

    // Append all data fields with proper validation
    Object.entries(data).forEach(([key, value]) => {
      // Skip image/carImage - we'll handle separately
      if (key === "carImage" || key === "image") {
        return;
      }

      // Handle arrays (like stops, inclusions, cancellation policies)
      if (key === "tags" && typeof value === "string") {
        const tagsArray = value
          .split(",")
          .map((tag) => tag.trim())
          .filter(Boolean);
        if (tagsArray.length > 0) {
          formData.append(key, JSON.stringify(tagsArray));
        } else {
          formData.append(key, JSON.stringify([]));
        }
        return;
      }
      if (Array.isArray(value)) {
        const normalizedArray = normalizeArrayForSubmit(value);
        if (key === "stops") {
          const nonEmptyStops = normalizedArray.filter(
            (stop) => stop && stop.trim && stop.trim(),
          );
          if (nonEmptyStops.length > 0) {
            formData.append(key, JSON.stringify(nonEmptyStops));
          }
          return;
        } else if (
          key === "inclusionsAndExclusions" ||
          key === "cancellationPolicy"
        ) {
          const nonEmpty = normalizedArray.filter(
            (item) => item && item.trim && item.trim(),
          );
          if (nonEmpty.length > 0) {
            formData.append(key, JSON.stringify(nonEmpty));
          } else {
            formData.append(key, "");
          }
          return;
        }
        formData.append(key, JSON.stringify(normalizedArray));
        return;
      }
      // Always include required fields, even if empty
      else if (requiredFields.includes(key)) {
        formData.append(key, value || "");
        return;
      }
      // For other fields, skip empty strings, null, or undefined
      if (value !== "" && value !== null && value !== undefined) {
        formData.append(key, value);
      }
    });

    // Append journey
    formData.append("journey", JSON.stringify(journey));

    // Append activity with default if empty
    if (!formData.has("activity")) {
      formData.append("activity", "-");
    }

    // Handle image upload
    // ✅ ONLY append image if user selected a new file
    if (files.carImage instanceof File) {
      formData.append("image", files.carImage);
    }

    // Log FormData for debugging
    console.log("FormData being submitted:");
    console.log("files.carImage:", files.carImage);
    console.log(
      "files.carImage instanceof File:",
      files.carImage instanceof File,
    );

    for (let [key, value] of formData.entries()) {
      if (value instanceof File) {
        console.log(
          `  ${key}: File - ${value.name} (${value.type}, ${value.size} bytes)`,
        );
      } else {
        console.log(`  ${key}:`, value);
      }
    }

    handleSubmit(formData);
  };

  const prepopulateDays = () => {
    if (data?.journey?.length) {
      const existingDays = data.journey.map((entry) => entry.day);
      const existingContent = data.journey.reduce((acc, entry) => {
        acc[entry.day] = entry.description;
        return acc;
      }, {});
      setDays(existingDays);
      setEditorContent(existingContent);
    }
  };

  const parseStringToArray = (value) => {
    if (!value) return [];
    if (Array.isArray(value)) return value;
    if (typeof value === "string") {
      // Try to parse as JSON first (for backend responses)
      try {
        const parsed = JSON.parse(value);
        if (Array.isArray(parsed)) {
          return parsed;
        }
      } catch (e) {
        // Not JSON, continue with newline split
      }
      // Fall back to newline split for legacy format
      return value.split("\n").filter((item) => item && item.trim());
    }
    return [];
  };

  // Safe utility to always get an array (for rendering)
  const ensureArray = (value) => {
    if (!value) return [];
    if (Array.isArray(value)) return value;
    return parseStringToArray(value);
  };

  useEffect(() => {
    if (isEditMode && data) {
      if (
        data.inclusionsAndExclusions &&
        !Array.isArray(data.inclusionsAndExclusions)
      ) {
        setData((prev) => ({
          ...prev,
          inclusionsAndExclusions: parseStringToArray(
            data.inclusionsAndExclusions,
          ),
        }));
      }
      if (data.cancellationPolicy && !Array.isArray(data.cancellationPolicy)) {
        setData((prev) => ({
          ...prev,
          cancellationPolicy: parseStringToArray(data.cancellationPolicy),
        }));
      }
    }
  }, [isEditMode, data]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const imageURL = URL.createObjectURL(file);
      setPreview(imageURL);
    }
  };

  const handleRemovePreview = () => {
    setPreview(null);
  };

  useEffect(() => {
    if (isEditMode && data) {
      prepopulateDays();
    }
  }, [data, isEditMode]);

  // Load vehicle list on component mount
  useEffect(() => {
    const loadVehicles = async () => {
      setLoadingVehicles(true);
      try {
        const response = await fetchAllVehiclesList();
        if (response?.data) {
          setVehiclesList(response.data);
        }
      } catch (error) {
        console.error("Error loading vehicles:", error);
        setVehiclesList([]);
      } finally {
        setLoadingVehicles(false);
      }
    };
    loadVehicles();
  }, []);

  // Calculate amounts based on location and vehicle segment
  const calculateAmounts = useCallback(async () => {
    const hasRequiredFields =
      data?.startLocation && data?.endLocation && data?.vehicleSegment;
    if (!hasRequiredFields) {
      return;
    }

    setCalculatingAmount(true);
    try {
      const token = localStorage.getItem("prima_session");
      if (!token) {
        console.error("No authentication token found");
        setCalculatingAmount(false);
        return;
      }

      // First calculate distance
      const distanceResponse = await axios.post(
        `${import.meta.env.VITE_API_URL}/management/calculate-distance`,
        {
          from: data.startLocation,
          to: data.endLocation,
          tripType: "OW", // Default to one-way for package
        },
        { headers: { Authorization: `Bearer ${token}` } },
      );

      const distance = distanceResponse?.data?.data?.distance || 0;

      // Then fetch fares for all vehicles
      const fareResponse = await axios.post(
        `${import.meta.env.VITE_API_URL}/management/find`,
        {
          from: data.startLocation,
          to: data.endLocation,
          tripType: "OW",
          pickupDate: new Date().toISOString().split("T")[0],
          pickupTime: "10:00",
          distance: distance,
        },
        { headers: { Authorization: `Bearer ${token}` } },
      );

      if (fareResponse?.data?.data && Array.isArray(fareResponse.data.data)) {
        // Find the fare for the selected vehicle segment
        const selectedFare = fareResponse.data.data.find(
          (fare) => fare.id === data.vehicleSegment,
        );

        if (selectedFare) {
          setData((prevData) => ({
            ...prevData,
            amountWithoutStay: selectedFare.customerPayable || "",
            amountWithStay: selectedFare.customerPayable || "",
          }));
        }
      }
    } catch (error) {
      console.error("Error calculating amounts:", error);
    } finally {
      setCalculatingAmount(false);
    }
  }, [data?.startLocation, data?.endLocation, data?.vehicleSegment]);

  // Watch for changes in location and vehicle segment to recalculate amounts
  useEffect(() => {
    const timer = setTimeout(() => {
      calculateAmounts();
    }, 500); // Debounce to avoid too many API calls

    return () => clearTimeout(timer);
  }, [
    data?.startLocation,
    data?.endLocation,
    data?.vehicleSegment,
    calculateAmounts,
  ]);

  return (
    <Box>
      <form ref={formRef} onSubmit={handleFormSubmit}>
        <Box px={6} py={8} borderRadius={"lg"} bg={"white"} my={"2rem"}>
                  
          <Heading fontSize="lg" mb={4} color={"#1A202C"}>
            Vehicle Segement Information
          </Heading>
          <Grid
            templateColumns={{ base: "1fr", md: "repeat(4, 1fr)" }}
            gap={4}
            mb={6}
          >
            <GridItem>
              <LabelInput
                placeholder={"Enter Unique Code"}
                label={"Unique Package Code"}
                name={"uniqueCode"}
                // borderRadius="0"
                value={data?.["uniqueCode"] || ""}
                onChange={handleInputChange}
                isRequired={true}
                isReadOnly={true}
              />
              {errors.uniqueCode && (
                <Text mt={1} fontSize="xs" color="red.500">
                  {errors.uniqueCode}
                </Text>
              )}
            </GridItem>
            <GridItem>
              <LabelInput
                placeholder={"Enter Package Title"}
                label={"Package Title"}
                name={"packageTitle"}
                // borderRadius="0"
                value={data?.["packageTitle"] || ""}
                onChange={handleInputChange}
                isRequired={true}
              />
              {errors.packageTitle && (
                <Text mt={1} fontSize="xs" color="red.500">
                  {errors.packageTitle}
                </Text>
              )}
            </GridItem>
          </Grid>
          <Grid
            templateColumns={{ base: "1fr", md: "repeat(3, 1fr)" }}
            gap={4}
            mb={6}
          >
            <GridItem>
              <Flex gap={2} align="flex-end">
                <Box flex="1" position="relative">
                  <FormLabel fontSize="sm" htmlFor="startLocation">
                    Start Location
                    <Text as="span" color="red.500" ml={1}>
                      *
                    </Text>
                  </FormLabel>
                  <Input
                    name="startLocation"
                    value={data.startLocation || ""}
                    onChange={(e) =>
                      handleLocationChange("startLocation", e.target.value)
                    }
                    onFocus={() => setShowStartDropdown(true)}
                    onBlur={() => {
                      setFieldError(
                        "startLocation",
                        validateField("startLocation", data.startLocation),
                      );
                      setTimeout(() => setShowStartDropdown(false), 200);
                    }}
                    placeholder="Enter start location"
                    {...filledInputStyles}
                    borderRadius="lg"
                    h="56px"
                    autoComplete="off"
                  />
                  {errors.startLocation && (
                    <Text mt={1} fontSize="xs" color="red.500">
                      {errors.startLocation}
                    </Text>
                  )}
                  {loadingStartLocation && (
                    <Spinner
                      size="sm"
                      position="absolute"
                      right="10px"
                      top="50%"
                      transform="translateY(-50%)"
                    />
                  )}
                  {showStartDropdown && startLocationSuggestions.length > 0 && (
                    <List
                      position="absolute"
                      zIndex={10}
                      bg="white"
                      border="1px solid grey.200"
                      borderColor="gray.200"
                      borderRadius="lg"
                      width="100%"
                      maxHeight="240px"
                      overflowY="auto"
                      mt={1}
                      boxShadow="lg"
                    >
                      {startLocationSuggestions.map((location, index) => (
                        <ListItem
                          key={index}
                          px={4}
                          py={2.5}
                          cursor="pointer"
                          _hover={{ bg: "blue.50" }}
                          _active={{ bg: "blue.100" }}
                          onMouseDown={() =>
                            handleLocationSelect("startLocation", location)
                          }
                        >
                          {location.description}
                        </ListItem>
                      ))}
                    </List>
                  )}
                </Box>
                {/* <Button
                  leftIcon={<FiPlus />}
                  colorScheme="blue"
                  size="md"
                  h="56px"
                  onClick={() => {
                    // Add location functionality placeholder
                    alert("Add new location feature - to be implemented");
                  }}
                >
                  Add
                </Button> */}
              </Flex>
            </GridItem>
            <GridItem>
              <Flex gap={2} align="flex-end">
                <Box flex="1" position="relative">
                  <FormLabel fontSize="sm" htmlFor="endLocation">
                    End Location
                    <Text as="span" color="red.500" ml={1}>
                      *
                    </Text>
                  </FormLabel>
                  <Input
                    name="endLocation"
                    value={data.endLocation || ""}
                    onChange={(e) =>
                      handleLocationChange("endLocation", e.target.value)
                    }
                    onFocus={() => setShowEndDropdown(true)}
                    onBlur={() => {
                      setFieldError(
                        "endLocation",
                        validateField("endLocation", data.endLocation),
                      );
                      setTimeout(() => setShowEndDropdown(false), 200);
                    }}
                    placeholder="Enter end location"
                    {...filledInputStyles}
                    borderRadius="lg"
                    h="56px"
                    autoComplete="off"
                  />
                  {errors.endLocation && (
                    <Text mt={1} fontSize="xs" color="red.500">
                      {errors.endLocation}
                    </Text>
                  )}
                  {loadingEndLocation && (
                    <Spinner
                      size="sm"
                      position="absolute"
                      right="10px"
                      top="50%"
                      transform="translateY(-50%)"
                    />
                  )}
                  {showEndDropdown && endLocationSuggestions.length > 0 && (
                    <List
                      position="absolute"
                      zIndex={10}
                      bg="white"
                      border="1px solid"
                      borderColor="gray.200"
                      borderRadius="lg"
                      width="100%"
                      maxHeight="240px"
                      overflowY="auto"
                      mt={1}
                      boxShadow="lg"
                    >
                      {endLocationSuggestions.map((location, index) => (
                        <ListItem
                          key={index}
                          px={4}
                          py={2.5}
                          cursor="pointer"
                          _hover={{ bg: "blue.50" }}
                          _active={{ bg: "blue.100" }}
                          onMouseDown={() =>
                            handleLocationSelect("endLocation", location)
                          }
                        >
                          {location.description}
                        </ListItem>
                      ))}
                    </List>
                  )}
                </Box>
              </Flex>
            </GridItem>
            <GridItem>
              <FormLabel fontSize="sm" htmlFor="activity">
                No of Days/Nights{" "}
                <Text as="span" color="red.500" ml={1}>
                  {" "}
                  *{" "}
                </Text>{" "}
              </FormLabel>{" "}
              <LabelInput
                placeholder={"Enter number of days"} // label={"No of Days/Nights"}
                name={"duration"}
                value={data?.["duration"] || ""}
                onChange={handleInputChange}
              />{" "}
              {errors.duration && (
                <Text mt={1} fontSize="xs" color="red.500">
                  {" "}
                  {errors.duration}{" "}
                </Text>
              )}
            </GridItem>
            <GridItem>
              <FormLabel fontSize="sm" htmlFor="activity">
                Select your activity
                <Text as="span" color="red.500" ml={1}>
                  *
                </Text>
              </FormLabel>
              <ChakraSelect
                name="activity"
                placeholder="Select your activity"
                options={activityOptions}
                value={activityOptions.find(
                  (option) => option.value === data.activity,
                )}
                onChange={handleSelectChange("activity")}
                chakraStyles={dropdownStyles}
              />
              {errors.activity && (
                <Text mt={1} fontSize="xs" color="red.500">
                  {errors.activity}
                </Text>
              )}
            </GridItem>
            <GridItem>
              <FormLabel fontSize="sm" htmlFor="category">
                Category
                <Text as="span" color="red.500" ml={1}>
                  *
                </Text>
              </FormLabel>
              <ChakraSelect
                name="category"
                placeholder="Select Your Category"
                options={categoryOptions}
                value={categoryOptions.find(
                  (option) => option.value === data.category,
                )}
                onChange={handleSelectChange("category")}
                chakraStyles={dropdownStyles}
              />
              {errors.category && (
                <Text mt={1} fontSize="xs" color="red.500">
                  {errors.category}
                </Text>
              )}
            </GridItem>
            <GridItem>
              <LabelInput
                placeholder={"e.g. family, weekend, budget"}
                label={"Tags (comma separated)"}
                name={"tags"}
                value={
                  Array.isArray(data?.["tags"])
                    ? data["tags"].join(", ")
                    : data?.["tags"] || ""
                }
                onChange={handleInputChange}
              />
            </GridItem>
            <GridItem>
              <FormLabel fontSize="sm" htmlFor="packageType">
                Select Package Type
                <Text as="span" color="red.500" ml={1}>
                  *
                </Text>
              </FormLabel>
              <ChakraSelect
                name="packageType"
                placeholder="Select Package Type"
                options={packageTypeOptions}
                value={packageTypeOptions.find(
                  (option) => option.value === data.packageType,
                )}
                onChange={handleSelectChange("packageType")}
                chakraStyles={dropdownStyles}
              />
              {errors.packageType && (
                <Text mt={1} fontSize="xs" color="red.500">
                  {errors.packageType}
                </Text>
              )}
            </GridItem>
            <GridItem>
              <LabelInput
                placeholder={"Travellers"}
                label={"Travellers"}
                name={"travellers"}
                // borderRadius="0"
                value={data?.["travellers"] || ""}
                onChange={handleInputChange}
                isRequired={true}
              />
              {errors.travellers && (
                <Text mt={1} fontSize="xs" color="red.500">
                  {errors.travellers}
                </Text>
              )}
            </GridItem>
            <GridItem>
              <FormLabel fontSize="sm" htmlFor="pricingType">
                Pricing Type
                <Text as="span" color="red.500" ml={1}>
                  *
                </Text>
              </FormLabel>
              <ChakraSelect
                name="pricingType"
                placeholder="Select pricing type"
                options={pricingTypeOptions}
                value={pricingTypeOptions.find(
                  (option) => option.value === data.pricingType,
                )}
                onChange={handleSelectChange("pricingType")}
                chakraStyles={dropdownStyles}
              />
              {errors.pricingType && (
                <Text mt={1} fontSize="xs" color="red.500">
                  {errors.pricingType}
                </Text>
              )}
            </GridItem>
            {data?.pricingType === "perPerson" && (
              <GridItem>
                <LabelInput
                  placeholder={"Minimum Travellers"}
                  label={"Minimum Travellers"}
                  name={"minTravellers"}
                  value={data?.["minTravellers"] || ""}
                  onChange={handleInputChange}
                />
              </GridItem>
            )}
            {data?.pricingType === "perVehicle" && (
              <GridItem>
                <FormLabel fontSize="sm" htmlFor="vehicleSegment">
                  Vehicle Segment{" "}
                  <Text as="span" color="red.500">
                    *
                  </Text>
                </FormLabel>
                <ChakraSelect
                  name="vehicleSegment"
                  placeholder={
                    loadingVehicles
                      ? "Loading vehicles..."
                      : "Select Vehicle Segment"
                  }
                  options={vehiclesList.map((vehicle) => ({
                    value: vehicle._id,
                    label: vehicle.segmentName || vehicle.name,
                  }))}
                  value={vehiclesList
                    .map((vehicle) => ({
                      value: vehicle._id,
                      label: vehicle.segmentName || vehicle.name,
                    }))
                    .find((option) => option.value === data?.vehicleSegment)}
                  onChange={(option) => {
                    const selectedVehicle = vehiclesList.find(
                      (v) => v._id === option?.value,
                    );
                    setData((prevData) => ({
                      ...prevData,
                      vehicleSegment: option?.value || "",
                      vehicleSegmentName:
                        selectedVehicle?.segmentName ||
                        selectedVehicle?.name ||
                        "",
                    }));
                  }}
                  isDisabled={loadingVehicles}
                  chakraStyles={dropdownStyles}
                />
                {errors.vehicleSegment && (
                  <Text mt={1} fontSize="xs" color="red.500">
                    {errors.vehicleSegment}
                  </Text>
                )}
              </GridItem>
            )}
            {/* <GridItem>
              <FormLabel fontSize="sm" htmlFor="currency">
                Currency
              </FormLabel>
              <ChakraSelect
                name="currency"
                placeholder="Select currency"
                options={currencyOptions}
                value={currencyOptions.find(
                  (option) => option.value === (data.currency || "INR"),
                )}
                onChange={handleSelectChange("currency")}
                chakraStyles={dropdownStyles}
              />
            </GridItem> */}
            <GridItem>
              <LabelInput
                placeholder={"Amount Without Stay"}
                label={"Amount Without Stay"}
                name={"amountWithoutStay"}
                value={data?.["amountWithoutStay"] || ""}
                onChange={handleInputChange}
                isRequired={true}
                isDisabled={calculatingAmount}
              />
              {calculatingAmount && (
                <Text mt={1} fontSize="xs" color="blue.500">
                  Calculating based on locations...
                </Text>
              )}
              {errors.amountWithoutStay && (
                <Text mt={1} fontSize="xs" color="red.500">
                  {errors.amountWithoutStay}
                </Text>
              )}
            </GridItem>
            <GridItem>
              <LabelInput
                placeholder={"Amount With Stay"}
                label={"Amount With Stay"}
                name={"amountWithStay"}
                value={data?.["amountWithStay"] || ""}
                onChange={handleInputChange}
                isRequired={true}
                isDisabled={calculatingAmount}
              />
              {calculatingAmount && (
                <Text mt={1} fontSize="xs" color="blue.500">
                  Calculating based on locations...
                </Text>
              )}
              {errors.amountWithStay && (
                <Text mt={1} fontSize="xs" color="red.500">
                  {errors.amountWithStay}
                </Text>
              )}
            </GridItem>
          </Grid>

          {/* Stops Section */}
          <Box mb={6}>
            <Flex justify="space-between" align="center" mb={4}>
              <Heading fontSize="md" color="#1A202C">
                Stops (Optional)
              </Heading>
              <Button
                onClick={addStop}
                size="md"
                variant="outline"
                colorScheme="blue"
                h="40px"
                leftIcon={<FiPlus />}
              >
                Add Stop
              </Button>
            </Flex>

            {(data.stops || []).length > 0 && (
              <VStack spacing={4} align="stretch">
                {(data.stops || []).map((stop, index) => (
                  <Flex key={index} gap={2} align="flex-start">
                    <Box flex="1" position="relative" maxW="33%">
                      <FormLabel fontSize="sm">Stop {index + 1}</FormLabel>
                      <Input
                        value={stop || ""}
                        onChange={(e) =>
                          handleStopChange(index, e.target.value)
                        }
                        onFocus={() =>
                          setShowStopsDropdown((prev) => ({
                            ...prev,
                            [index]: true,
                          }))
                        }
                        onBlur={() =>
                          setTimeout(
                            () =>
                              setShowStopsDropdown((prev) => ({
                                ...prev,
                                [index]: false,
                              })),
                            200,
                          )
                        }
                        placeholder={`Enter stop ${index + 1} location`}
                        {...filledInputStyles}
                        borderRadius="lg"
                        h="56px"
                        autoComplete="off"
                      />
                      {loadingStops[index] && (
                        <Spinner
                          size="sm"
                          position="absolute"
                          right="10px"
                          top="60%"
                          transform="translateY(-50%)"
                        />
                      )}
                      {showStopsDropdown[index] &&
                        stopsSuggestions[index]?.length > 0 && (
                          <List
                            position="absolute"
                            zIndex={10}
                            bg="white"
                            border="1px solid"
                            borderColor="gray.200"
                            borderRadius="lg"
                            width="100%"
                            maxHeight="240px"
                            overflowY="auto"
                            mt={1}
                            boxShadow="lg"
                          >
                            {stopsSuggestions[index].map((location, idx) => (
                              <ListItem
                                key={idx}
                                px={4}
                                py={2.5}
                                cursor="pointer"
                                _hover={{ bg: "blue.50" }}
                                _active={{ bg: "blue.100" }}
                                onMouseDown={() =>
                                  handleStopSelect(index, location)
                                }
                              >
                                {location.description}
                              </ListItem>
                            ))}
                          </List>
                        )}
                    </Box>
                    <IconButton
                      onClick={() => removeStop(index)}
                      colorScheme="red"
                      variant="ghost"
                      size="md"
                      h="56px"
                      mt="22px"
                      icon={<FiTrash2 />}
                      aria-label="Remove stop"
                    />
                  </Flex>
                ))}
              </VStack>
            )}
          </Box>

          <Grid
            templateColumns={{ base: "1fr", md: "repeat(3, 1fr)" }}
            gap={4}
            mb={0}
          ></Grid>
        </Box>

        <Box px={6} py={6} borderRadius={"lg"} bg={"white"} my={"2rem"}>
          {/* Promotions & Offers */}
          <Box mb={6}>
            <Heading fontSize="lg" color={"#1A202C"} mb={4}>
              Promotions & Offers
            </Heading>
            <Grid
              templateColumns={{ base: "1fr", md: "repeat(3, 1fr)" }}
              gap={4}
            >
              <GridItem>
                <LabelInput
                  placeholder={"Promotion"}
                  label={"Promotion"}
                  name={"promotion"}
                  value={data?.["promotion"] || ""}
                  onChange={handleInputChange}
                />
              </GridItem>
              <GridItem>
                <FormLabel fontSize="sm" htmlFor="promoStartDate">
                  Start Date
                </FormLabel>
                <Input
                  type="date"
                  name="promoStartDate"
                  value={data.promoStartDate || ""}
                  onChange={handleInputChange}
                  min={todayDate}
                  {...filledInputStyles}
                  borderRadius="lg"
                  h="56px"
                />
              </GridItem>
              <GridItem>
                <FormLabel fontSize="sm" htmlFor="promoEndDate">
                  End Date
                </FormLabel>
                <Input
                  type="date"
                  name="promoEndDate"
                  value={data.promoEndDate || ""}
                  onChange={handleInputChange}
                  min={data.promoStartDate || todayDate}
                  {...filledInputStyles}
                  borderRadius="lg"
                  h="56px"
                />
              </GridItem>
            </Grid>
          </Box>

          {/* Dynamic Pricing / Price Surge */}
          <Box mb={6}>
            <Heading fontSize="lg" color={"#1A202C"} mb={4}>
              Price Surge
            </Heading>
            <Grid
              templateColumns={{ base: "1fr", md: "repeat(3, 1fr)" }}
              gap={4}
            >
              <GridItem>
                <LabelInput
                  placeholder={"Surge Price"}
                  label={"Surge Price"}
                  name={"surgePrice"}
                  value={data?.["surgePrice"] || ""}
                  onChange={handleInputChange}
                />
              </GridItem>
              <GridItem>
                <FormLabel fontSize="sm" htmlFor="surgeStartDate">
                  Start Date
                </FormLabel>
                <Input
                  type="date"
                  name="surgeStartDate"
                  value={data.surgeStartDate || ""}
                  onChange={handleInputChange}
                  min={todayDate}
                  {...filledInputStyles}
                  borderRadius="lg"
                  h="56px"
                />
              </GridItem>
              <GridItem>
                <FormLabel fontSize="sm" htmlFor="surgeEndDate">
                  End Date
                </FormLabel>
                <Input
                  type="date"
                  name="surgeEndDate"
                  value={data.surgeEndDate || ""}
                  onChange={handleInputChange}
                  min={data.surgeStartDate || todayDate}
                  {...filledInputStyles}
                  borderRadius="lg"
                  h="56px"
                />
              </GridItem>
            </Grid>
          </Box>

          {/* Product Status */}
          <Box mb={6}>
            <Heading fontSize="lg" color={"#1A202C"} mb={4}>
              Product Status
            </Heading>
            <Grid
              templateColumns={{ base: "1fr", md: "repeat(4, 1fr)" }}
              gap={4}
            >
              <GridItem>
                <FormLabel fontSize="sm" htmlFor="productStatus">
                  Status
                </FormLabel>
                <ChakraSelect
                  name="productStatus"
                  options={productStatusOptions}
                  value={productStatusOptions.find(
                    (option) =>
                      option.value === (data.productStatus || "draft"),
                  )}
                  onChange={handleSelectChange("productStatus")}
                  chakraStyles={dropdownStyles}
                />
              </GridItem>
            </Grid>
          </Box>

          {/* Inclusions and Exclusions */}
          <Box mb={6}>
            <Flex justify="space-between" align="center" mb={4}>
              <Heading fontSize="lg" color={"#1A202C"}>
                Inclusions and Exclusions
                <Text as="span" color="red.500" ml={1}>
                  *
                </Text>
              </Heading>
              <Button
                onClick={addInclusion}
                size="md"
                variant="outline"
                colorScheme="blue"
                h="40px"
                leftIcon={<FiPlus />}
              >
                Add Item
              </Button>
            </Flex>

            {ensureArray(data.inclusionsAndExclusions).length > 0 && (
              <VStack spacing={4} align="stretch">
                {ensureArray(data.inclusionsAndExclusions).map(
                  (item, index) => (
                    <Flex key={index} gap={2} align="flex-start">
                      <Box flex="1">
                        <FormLabel fontSize="sm">Item {index + 1}</FormLabel>
                        <Input
                          value={item || ""}
                          onChange={(e) =>
                            handleInclusionChange(index, e.target.value)
                          }
                          placeholder={`Enter inclusion/exclusion ${index + 1}`}
                          {...filledInputStyles}
                          borderRadius="lg"
                          h="56px"
                        />
                      </Box>
                      <IconButton
                        onClick={() => removeInclusion(index)}
                        colorScheme="red"
                        variant="ghost"
                        size="md"
                        h="56px"
                        mt="22px"
                        icon={<FiTrash2 />}
                        aria-label="Remove inclusion"
                      />
                    </Flex>
                  ),
                )}
              </VStack>
            )}
          </Box>

          {/* Cancellation Policy */}
          <Box>
            <Flex justify="space-between" align="center" mb={4}>
              <Heading fontSize="lg" color={"#1A202C"}>
                Cancellation Policy
                <Text as="span" color="red.500" ml={1}>
                  *
                </Text>
              </Heading>
              <Button
                onClick={addCancellationPolicy}
                size="md"
                variant="outline"
                colorScheme="blue"
                h="40px"
                leftIcon={<FiPlus />}
              >
                Add Policy
              </Button>
            </Flex>

            {ensureArray(data.cancellationPolicy).length > 0 && (
              <VStack spacing={4} align="stretch">
                {ensureArray(data.cancellationPolicy).map((item, index) => (
                  <Flex key={index} gap={2} align="flex-start">
                    <Box flex="1">
                      <FormLabel fontSize="sm">Policy {index + 1}</FormLabel>
                      <Input
                        value={item || ""}
                        onChange={(e) =>
                          handleCancellationPolicyChange(index, e.target.value)
                        }
                        placeholder={`Enter cancellation policy ${index + 1}`}
                        {...filledInputStyles}
                        borderRadius="lg"
                        h="56px"
                      />
                    </Box>
                    <IconButton
                      onClick={() => removeCancellationPolicy(index)}
                      colorScheme="red"
                      variant="ghost"
                      size="md"
                      h="56px"
                      mt="22px"
                      icon={<FiTrash2 />}
                      aria-label="Remove policy"
                    />
                  </Flex>
                ))}
              </VStack>
            )}
          </Box>
        </Box>
        <Box px={6} py={6} borderRadius={"lg"} bg={"white"} my={"2rem"}>
          {/* Journey Section */}
          <Text fontWeight="bold" mb={4}>
            Journey Plan (Days)
          </Text>
          {!canAddDays && (
            <Text fontSize="sm" color="red.500" mb={4}>
              Enter a valid duration (days) to add journey details.
            </Text>
          )}
          <VStack spacing={4} align="stretch">
            {days?.map((day) => (
              <Box key={day} bg="gray.50" p={4} borderRadius="md">
                <Flex align="center" justify="space-between" mb={2}>
                  <Text fontSize="lg" fontWeight="bold">
                    ▼ Day {day}
                  </Text>
                  <IconButton
                    aria-label="Remove Day"
                    icon={<RxCrossCircled />}
                    colorScheme="red"
                    variant="ghost"
                    size="sm"
                    onClick={() => handleRemoveDay(day)}
                    isDisabled={!canAddDays}
                  />
                </Flex>
                <Box position="relative" mb={4}>
                  <Input
                    placeholder="Enter location or main highlight for Day"
                    value={editorContent[`${day}_location`] || ""}
                    onChange={async (e) => {
                      const val = e.target.value;
                      handleEditorChange(`${day}_location`, val);
                      // Show spinner and fetch suggestions
                      setLoadingStartLocation(true);
                      setShowStartDropdown(true);
                      let suggestions = [];
                      if (val.length > 2) {
                        try {
                          const response = await fetchSuggestions(val, 'address');
                          suggestions = response?.data || [];
                          setStartLocationSuggestions(suggestions);
                        } catch (err) {
                          setStartLocationSuggestions([]);
                        }
                      } else {
                        setStartLocationSuggestions([]);
                      }
                      setLoadingStartLocation(false);
                    }}
                    onFocus={() => setShowStartDropdown(true)}
                    onBlur={() => setTimeout(() => setShowStartDropdown(false), 200)}
                  />
                  {loadingStartLocation && (
                    <Spinner
                      size="sm"
                      position="absolute"
                      right="10px"
                      top="50%"
                      transform="translateY(-50%)"
                    />
                  )}
                  {showStartDropdown && startLocationSuggestions.length > 0 && (
                    <List
                      position="absolute"
                      zIndex={10}
                      bg="white"
                      border="1px solid grey.200"
                      borderColor="gray.200"
                      borderRadius="lg"
                      width="100%"
                      maxHeight="240px"
                      overflowY="auto"
                      mt={1}
                      boxShadow="lg"
                    >
                      {startLocationSuggestions.map((location, index) => (
                        <ListItem
                          key={index}
                          px={4}
                          py={2.5}
                          cursor="pointer"
                          _hover={{ bg: "blue.50" }}
                          _active={{ bg: "blue.100" }}
                          onMouseDown={() => {
                            handleEditorChange(`${day}_location`, location.description);
                            setShowStartDropdown(false);
                            setStartLocationSuggestions([]);
                          }}
                        >
                          {location.description}
                        </ListItem>
                      ))}
                    </List>
                  )}
                </Box>
                {/* Itinerary Section */}
                <Box mb={4}>
                  <Text fontWeight="bold" mb={2}>Itinerary</Text>
                  {(editorContent[`${day}_itinerary`] || []).map((item, idx) => (
                    <Box key={idx} mb={2}>
                      <Input
                        placeholder="Attraction or place name"
                        value={item.title || ''}
                        onChange={e => {
                          const arr = [...(editorContent[`${day}_itinerary`] || [])];
                          arr[idx].title = e.target.value;
                          handleEditorChange(`${day}_itinerary`, arr);
                        }}
                        mb={2}
                      />
                      {/* Input for itinerary description */}
                      <Textarea
                        placeholder="Enter itinerary details for this attraction"
                        value={item.description || ''}
                        onChange={(e) => {
                          const arr = [...(editorContent[`${day}_itinerary`] || [])];
                          arr[idx].description = e.target.value;
                          handleEditorChange(`${day}_itinerary`, arr);
                        }}
                        mt={2}
                      />
                      <HStack spacing={1} mt={1}>
                        
                        <IconButton
                          size="sm"
                          variant="ghost"
                          colorScheme="red"
                          aria-label="Delete"
                          icon={<FiTrash2 />}
                          isRound
                          onClick={() => {
                            const arr = [...(editorContent[`${day}_itinerary`] || [])];
                            arr.splice(idx, 1);
                            handleEditorChange(`${day}_itinerary`, arr);
                          }}
                        />
                      </HStack>
                    </Box>
                  ))}
                  <Button variant="link" colorScheme="teal" size="sm" onClick={() => {
                    const arr = [...(editorContent[`${day}_itinerary`] || [])];
                    arr.push({ title: '', description: '' });
                    handleEditorChange(`${day}_itinerary`, arr);
                  }}>+ Add an attraction</Button>
                </Box>
                {/* Food & Drinks Section */}
                <Box mb={4}>
                  <Text fontWeight="bold" mb={2}>Food & Drinks <span style={{ fontSize: 'smaller' }}>?</span></Text>
                  {(editorContent[`${day}_meals`] || []).map((item, idx) => (
                    <Box key={idx} mb={2}>
                      <Input
                        placeholder="Meal type (e.g. Breakfast, Lunch)"
                        value={item.type || ''}
                        onChange={(e) => {
                          const arr = [...(editorContent[`${day}_meals`] || [])];
                          arr[idx].type = e.target.value;
                          handleEditorChange(`${day}_meals`, arr);
                        }}
                      />
                      <Input
                        placeholder="Menu details (e.g. egg and bread)"
                        value={item.menu || ''}
                        onChange={(e) => {
                          const arr = [...(editorContent[`${day}_meals`] || [])];
                          arr[idx].menu = e.target.value;
                          handleEditorChange(`${day}_meals`, arr);
                        }}
                        mt={2}
                      />
                      <HStack spacing={1} mt={1}>
                        <IconButton
                          size="sm"
                          variant="ghost"
                          colorScheme="blue"
                          aria-label="Edit"
                          icon={<FiPlus style={{ transform: 'rotate(45deg)' }} />}
                          isRound
                          onClick={() => {/* edit logic */}}
                        />
                        <IconButton
                          size="sm"
                          variant="ghost"
                          colorScheme="red"
                          aria-label="Delete"
                          icon={<FiTrash2 />}
                          isRound
                          onClick={() => {
                            const arr = [...(editorContent[`${day}_meals`] || [])];
                            arr.splice(idx, 1);
                            handleEditorChange(`${day}_meals`, arr);
                          }}
                        />
                      </HStack>
                    </Box>
                  ))}
                  <Button variant="link" colorScheme="teal" size="sm" onClick={() => {
                    const arr = [...(editorContent[`${day}_meals`] || [])];
                    arr.push({ type: '', menu: '' });
                    handleEditorChange(`${day}_meals`, arr);
                  }}>+ Add a meal</Button>
                </Box>
                {/* Accommodation Section */}
                <Box mb={4}>
                  <Text fontWeight="bold" mb={2}>Accommodation <span style={{ fontSize: 'smaller' }}>?</span></Text>
                  <Input
                    placeholder="Accommodation details"
                    value={editorContent[`${day}_accommodation`] || ''}
                    onChange={(e) => handleEditorChange(`${day}_accommodation`, e.target.value)}
                  />
                </Box>
              </Box>
            ))}
          </VStack>

          <HStack justify="end" mb={6} mt={6}>
            <Button
              leftIcon={<MdOutlineAddBox />}
              size="sm"
              colorScheme="orange"
              variant="outline"
              borderRadius="md"
              onClick={handleAddDay}
              isDisabled={!canAddDays || isAtDayLimit}
            >
              Add Day
            </Button>
          </HStack>
        </Box>
            {/* Day-wise Pricing & Schedule Payment System (Optional) */}
            {/* <Box px={6} py={6} borderRadius={"lg"} bg={"white"} my={"2rem"}>
              <Flex align="center" mb={4}>
                <Heading fontSize="lg" color="#1A202C" mr={4}>
                  Day-wise Pricing & Payment Schedule
                </Heading>
                <Switch
                  colorScheme="teal"
                  isChecked={showDaywisePricing}
                  onChange={() => setShowDaywisePricing((v) => !v)}
                  size="md"
                  mr={2}
                />
              </Flex>
              {showDaywisePricing && (
                <>
                  <Text fontSize="sm" color="gray.600" mb={4}>
                    Set prices, payment schedule, and commission for each day of the package. You can also specify start times and applicable days.
                  </Text>
                  <VStack spacing={6} align="stretch">
                    {days?.map((day) => (
                      <Box key={day} bg="gray.50" p={4} borderRadius="md">
                        <Flex align="center" justify="space-between" mb={2}>
                          <Text fontSize="md" fontWeight="bold">
                            Day {day} Pricing & Schedule
                          </Text>
                        </Flex>
                        <Grid templateColumns={{ base: "1fr", md: "repeat(4, 1fr)" }} gap={4} mb={4}>
                          <GridItem>
                            <LabelInput
                              placeholder={"Max travelers"}
                              label={"Max Travelers"}
                              name={`day_${day}_maxTravelers`}
                              value={data[`day_${day}_maxTravelers`] || ""}
                              onChange={handleInputChange}
                            />
                          </GridItem>
                          <GridItem>
                            <LabelInput
                              placeholder={"Retail Price"}
                              label={"Suggested Retail Price"}
                              name={`day_${day}_retailPrice`}
                              value={data[`day_${day}_retailPrice`] || ""}
                              onChange={handleInputChange}
                            />
                          </GridItem>
                          <GridItem>
                            <LabelInput
                              placeholder={"Amount Paid"}
                              label={"Amount You Get Paid"}
                              name={`day_${day}_amountPaid`}
                              value={data[`day_${day}_amountPaid`] || ""}
                              onChange={handleInputChange}
                            />
                          </GridItem>
                          <GridItem>
                            <LabelInput
                              placeholder={"Commission %"}
                              label={"Commission Rate (%)"}
                              name={`day_${day}_commissionRate`}
                              value={data[`day_${day}_commissionRate`] || ""}
                              onChange={handleInputChange}
                            />
                          </GridItem>
                        </Grid>
                        <Box mb={4}>
                          <Text fontSize="sm" fontWeight="bold" mb={2}>Select Days</Text>
                          <HStack spacing={2}>
                            {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((d) => (
                              <Button
                                key={d}
                                size="sm"
                                variant={data[`day_${day}_days`] && data[`day_${day}_days`].includes(d) ? "solid" : "outline"}
                                colorScheme="teal"
                                onClick={() => {
                                  const prev = data[`day_${day}_days`] || [];
                                  setData((prevData) => ({
                                    ...prevData,
                                    [`day_${day}_days`]: prev.includes(d)
                                      ? prev.filter((x) => x !== d)
                                      : [...prev, d],
                                  }));
                                }}
                              >
                                {d}
                              </Button>
                            ))}
                          </HStack>
                        </Box>
                        <Box mb={4}>
                          <Text fontSize="sm" fontWeight="bold" mb={2}>Start Times</Text>
                          <HStack spacing={2}>
                            {(data[`day_${day}_startTimes`] || []).map((t, idx) => (
                              <Box key={idx}>
                                <Input
                                  type="time"
                                  value={t}
                                  onChange={(e) => {
                                    const times = [...(data[`day_${day}_startTimes`] || [])];
                                    times[idx] = e.target.value;
                                    setData((prevData) => ({
                                      ...prevData,
                                      [`day_${day}_startTimes`]: times,
                                    }));
                                  }}
                                  size="sm"
                                />
                                <IconButton
                                  icon={<RxCrossCircled />}
                                  size="sm"
                                  colorScheme="red"
                                  variant="ghost"
                                  ml={2}
                                  onClick={() => {
                                    const times = (data[`day_${day}_startTimes`] || []).filter((_, i) => i !== idx);
                                    setData((prevData) => ({
                                      ...prevData,
                                      [`day_${day}_startTimes`]: times,
                                    }));
                                  }}
                                  aria-label="Remove time"
                                />
                              </Box>
                            ))}
                            <Button
                              leftIcon={<MdOutlineAddBox />}
                              size="sm"
                              colorScheme="orange"
                              variant="outline"
                              onClick={() => {
                                setData((prevData) => ({
                                  ...prevData,
                                  [`day_${day}_startTimes`]: [
                                    ...(prevData[`day_${day}_startTimes`] || []),
                                    "",
                                  ],
                                }));
                              }}
                            >
                              Add Time
                            </Button>
                          </HStack>
                        </Box>
                        <Box mb={4}>
                          <Text fontSize="sm" fontWeight="bold" mb={2}>Payment Schedule</Text>
                          <HStack spacing={2}>
                            <LabelInput
                              placeholder={"Payment Due Date"}
                              label={"Due Date"}
                              name={`day_${day}_paymentDueDate`}
                              value={data[`day_${day}_paymentDueDate`] || ""}
                              onChange={handleInputChange}
                              type="date"
                            />
                            <LabelInput
                              placeholder={"Payment Amount"}
                              label={"Amount"}
                              name={`day_${day}_paymentAmount`}
                              value={data[`day_${day}_paymentAmount`] || ""}
                              onChange={handleInputChange}
                            />
                          </HStack>
                        </Box>
                      </Box>
                    ))}
                  </VStack>
                </>
              )}
            </Box> */}
        
        <Grid
          templateColumns={{
            base: "1fr",
            md: "repeat(2, 1fr)",
            // lg: "repeat(4,1fr)",
          }}
          gap={4}
          mb={6}
        >
          <GridItem>
            <InputAndDragAndDrop
              title="Upload Car Image"
              name="carImage"
              url={data?.image}
              setFiles={setFiles}
              setFieldValue={(name, value) => {
                setData((prev) => ({ ...prev, [name]: value }));
              }}
              setFieldTouched={(name) => {
                // Optional: handle field touched state if needed
              }}
            />
            {/* </Box> */}
          </GridItem>
          <GridItem>
            {/* Save and Cancel Buttons */}
            <Flex
              h={"100%"}
              justifyContent="flex-end"
              alignItems={"flex-end"}
              gap={4}
            >
              <Button
                variant="outline"
                borderColor="#396AFF"
                borderWidth={2}
                color="#396AFF"
                size={"sm"}
                bg="white"
                _hover={{
                  border: "none",
                  bg: "grey",
                  color: "black",
                }}
                borderRadius={5}
                px={35}
                fontWeight={600}
                py={5}
                onClick={() => navigate("/management/packages")}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                colorScheme="blue"
                borderColor="#396AFF"
                borderWidth={2}
                size={"sm"}
                borderRadius={5}
                px={10}
                fontWeight={600}
                w={"20%"}
                py={5}
                isLoading={isSaving}
                isDisabled={isSaving}
                loadingText="Saving..."
              >
                {isSaving ? "Saving..." : "Save"}
              </Button>
            </Flex>
          </GridItem>
        </Grid>
       
      </form>
    </Box>
  );
};
Form.propTypes = {
  data: PropTypes.object.isRequired,
  setData: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  formRef: PropTypes.object,
  isEditMode: PropTypes.bool,
  isSaving: PropTypes.bool,
};

export default Form;